import { render, staticRenderFns } from "./SmileIcon.vue?vue&type=template&id=5d07fd02&"
import script from "./SmileIcon.vue?vue&type=script&lang=js&"
export * from "./SmileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports